<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-05-18 11:16:54
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-24 14:30:06
 * @FilePath: \partner.chaoyongtuan.com\src\views\common\autoAddress\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog
		title="地址智能识别"
		:visible.sync="visible"
		width="407px"
		:before-close="handleClose"
		:close-on-click-modal="false"
		:append-to-body="true"
	>
		<div class="autoAddress">
			<el-form ref="form" :model="form" :rules="rules">
				<el-form-item label="" prop="address">
					<el-input
						type="textarea"
						:rows="4"
						placeholder="请粘贴或输入文本，点击“识别”自动识别姓名、电话和地址。示例：张三，188xxxx8918，浙江省杭州市拱墅区xx小区"
						v-model="form.address"
					>
					</el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="footer-dialog" slot="footer">
			<el-button type="primary" @click="confirm">识 别</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { getAddress } from '@/api/common';
export default {
	data() {
		return {
			visible: false,
			form: {
				address: '',
			},
			rules: {
				address: { required: true, message: '请输入地址', trigger: 'blur' },
			},
		};
	},
	methods: {
		show() {
			this.visible = true;
		},
		async confirm() {
			this.$refs.form.validate(async valid => {
				if (valid) {
					const { address } = this.form;
					const { code, data } = await getAddress({ address });
					if (code !== 0) return;
					this.$emit('returnValue', data);
					this.handleClose();
				}
			});
		},
		handleClose() {
			this.form = {
				address: '',
			};
			this.$refs['form'].resetFields();
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped></style>
